// Build Version (semantic versioning)
export const BUILD_VERSION = '3.4.0';

// API Configuration
export const API_BASE_URL = 'https://notepad-custom.thesocialaudience.workers.dev/api';

// Sync Configuration
export const SYNC_INTERVAL_MS = 30000; // 30 segundos

// Autosave Configuration
export const AUTOSAVE_DELAY_MS = 2000; // Ya no se usa para server, solo referencia
export const SERVER_AUTOSAVE_INTERVAL_MS = 60000; // 60 segundos para guardar en servidor

// History Configuration
export const MAX_HISTORY_VERSIONS = 20;

// Google Drive Configuration (se llenarán cuando se configure)
export const GOOGLE_CLIENT_ID = '';
export const GOOGLE_REDIRECT_URI = '';

// Editor Configuration
export const EDITOR_CONFIG = {
  tabSize: 4,
  lineWrapping: true,
  lineNumbers: true
};

// Indent Configuration
export const INDENT_UNIT = '    '; // 4 spaces
